import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import cartEmpty from '../../../assets/icons/cart-white-empty.svg'
import cartFill from '../../../assets/icons/cart-white-fill.svg'
import paths from '../../../routes/paths'
import { clsx } from '../../../utils/helper'
import FormatCurrency from '../../elements/FormatCurrency'

const CartShortcut = ({ menuUI, hideCart, total, countNewOrder }) => {
    const { t } = useTranslation()

    return (
        <Link
            to={paths.cartDetail}
            className={clsx(['cart-shortcut-mobile', hideCart && 'hide-cart'])}
        >
            {menuUI}
            <div className="cart-count-box">
                {t(countNewOrder < 2 ? 'shortcutCartMobile.lbDishCount1' : 'shortcutCartMobile.lbDishCountn', { count: countNewOrder })}
            </div>
            <div className="cart-money">
                <FormatCurrency amount={total} />
            </div>
            <div className="cart-icon d-flex">
                <img
                    alt="icon cart"
                    width="22px"
                    height="22px"
                    src={countNewOrder ? cartFill : cartEmpty}
                    className="mr-1"
                />
            </div>
        </Link>
    )
}

export default CartShortcut
